import { apiInterceptor, publicApiInterceptor } from "./api";
import { API_ENDPOINTS } from "@/config/apiEndpoints";

const loginApi = async (payload: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.LOGIN, payload);
  return response;
};

const sendOtpApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD_SEND_OTP, data);
  return response;
};

const resetPasswordApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, data);
  return response;
};

const changePasswordApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, data);
  return response;
};

const updateDetailsApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.put(API_ENDPOINTS.AUTH.PROFILE_UPDATE, data);
  return response;
};

const updateUserApi = async (id: any, data: any): Promise<any> => {
  const response = await apiInterceptor.put(`${API_ENDPOINTS.USER.UPDATE_USER}/${id}`, data);
  return response;
};

const getRoleListApi = async (): Promise<any> => {
  const response = await publicApiInterceptor.get(API_ENDPOINTS.COMMON.ROLE_LIST);
  return response;
};

const getAccessLevelListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.ACCESS_LEVEL_LIST);
  return response;
};

const getPermissionListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.PERMISSION_LIST);
  return response;
};

const getUserListApi = async (params: any): Promise<any> => {
  let apiParam = ''
  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`
  }

  if (params?.search && params?.search !== '') {
    apiParam = `${apiParam}&search=${params?.search}`
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.USER.USER_LIST}${apiParam}`);
  return response;
};

const getUserDetailApi = async (userId: string): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.USER.GET_USER_DETAIL}?user_id=${userId}`);
  return response;
};

const getProfileApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.AUTH.PROFILE_GET}`);
  return response;
};

const deleteUserApi = async (id: any): Promise<any> => {
  const response = await apiInterceptor.delete(`${API_ENDPOINTS.USER.USER_DELETE.replace('{{id}}', id)}`);
  return response;
};

const createUserApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.USER.CREATE_USER, data);
  return response;
};

const getChartDataByKpiApi = async (kpiId: string, session: string, year: string, baselineYearStart: string, baselineYearEnd: string, targetYearStart: string, targetYearEnd: string): Promise<any> => {
  // const response = await apiInterceptor.get(`${API_ENDPOINTS.CHART.GET_CHART_DATA_BY_KPI.replace('{{kpi_id}}', kpiId)}&gbm_type=${session}&reporting_year=${year}`);
  const response = await apiInterceptor.get(`${API_ENDPOINTS.CHART.CBK}kpi_id=${kpiId}&gbm_type=${session}&reporting_year=${year}&baseline_year_start=${baselineYearStart}&baseline_year_end=${baselineYearEnd}&target_year_start=${targetYearStart}&target_year_end=${targetYearEnd}`);
  return response;
};

const getChartDataApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.CHART.GET_CHART_DATA);
  return response;
};



// Role Management APIs
const getRoleManagementListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.ROLE.ROLE_LIST);
  return response;
};

const createRoleApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.ROLE.CREATE_ROLE, data);
  return response;
};

const updateRoleApi = async (id: string, data: any): Promise<any> => {
  const response = await apiInterceptor.put(API_ENDPOINTS.ROLE.UPDATE_ROLE.replace('{{id}}', id), data);
  return response;
};

const deleteRoleApi = async (id: string): Promise<any> => {
  const response = await apiInterceptor.delete(API_ENDPOINTS.ROLE.DELETE_ROLE.replace('{{id}}', id));
  return response;
};

// Permission Management APIs
const getPermissionManagementListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.PERMISSION.PERMISSION_LIST);
  return response;
};

const createPermissionApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.PERMISSION.CREATE_PERMISSION, data);
  return response;
};

const updatePermissionApi = async (id: string, data: any): Promise<any> => {
  const response = await apiInterceptor.put(API_ENDPOINTS.PERMISSION.UPDATE_PERMISSION.replace('{{id}}', id), data);
  return response;
};

const deletePermissionApi = async (id: string): Promise<any> => {
  const response = await apiInterceptor.delete(API_ENDPOINTS.PERMISSION.DELETE_PERMISSION.replace('{{id}}', id));
  return response;
};

// Template Management APIs
const getTemplateListApi = async (params: any): Promise<any> => {
  let apiParam = ''

  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`
  }

  if (params?.search && params?.search !== '') {
    apiParam = `${apiParam}&search=${params?.search}`
  }

  if (params?.sort_by && params?.sort_by !== '') {
    apiParam = `${apiParam}&sort_by=${params?.sort_by}`
  }

  if (params?.sort_order && params?.sort_order !== '') {
    apiParam = `${apiParam}&sort_order=${params?.sort_order}`
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.TEMPLATE.TEMPLATE_LIST}${apiParam}`);
  return response;
};

const getTemplateForUserApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.TEMPLATE.TEMPLATE_FOR_USER);
  return response;
};

const uploadTemplateApi = async (templateId: string, file: File): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiInterceptor.post(
    `${API_ENDPOINTS.TEMPLATE.UPLOAD_TEMPLATE}?template_id=${templateId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response;
};

const createTemplateApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.TEMPLATE.CREATE_TEMPLATE, data);
  return response;
};

const getTemplateDetailApi = async (id: string): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.TEMPLATE.GET_TEMPLATE_DETAIL.replace('{{id}}', id));
  return response;
};

const deleteTemplateApi = async (id: string): Promise<any> => {
  const response = await apiInterceptor.delete(API_ENDPOINTS.TEMPLATE.DELETE_TEMPLATE.replace('{{id}}', id));
  return response;
};

const deleteTemplateDataApi = async (params: any): Promise<any> => {

  let apiParam = ''
  if (params?.template_id && params?.template_id !== '') {
    apiParam += `${apiParam}?template_id=${params?.template_id}`
  }

  if (params?.session && params?.session !== '') {
    apiParam += `&session=${params?.session}`
  }

  if (params?.year && params?.year !== '') {
    apiParam += `&year=${params?.year}`
  }

  const response = await apiInterceptor.delete(API_ENDPOINTS.TEMPLATE.DELETE_TEMPLATE_DATA + apiParam);
  return response;
};


const downloadTemplateApi = async (id: string, formatType: string = 'csv'): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.TEMPLATE.DOWNLOAD_TEMPLATE.replace('{{id}}', id)}?formatType=${formatType}`, {
    responseType: 'blob'
  });
  return response;
};


// Indicator Management APIs
const getIndicatorListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.INDICATOR_LIST);
  return response;
};


const signupApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.SIGNUP, data);
  return response;
};


const verifyOtpApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.VERIFY_OTP, data);
  return response;
};


const getPhoneCodeApi = async (): Promise<any> => {
  const response = await publicApiInterceptor.get(API_ENDPOINTS.COMMON.PHONE_CODE);
  return response;
};





const resendOtpApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.RESEND_OTP, data);
  return response;
};

const getChartListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.CHART.GET_CHART_LIST}`);
  return response;
};

const getChartDetailsApi = async (id: string): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.CHART.GET_CHART_DETAILS.replace('{{id}}', id)}`);
  return response;
};

const getActivityLogApi = async (params: any): Promise<any> => {

  let apiParam = ''
  if (params?.page && params?.pageSize) {
    apiParam += `?page=${params?.page}&pageSize=${params?.pageSize}`
  }

  if (params?.search && params?.search !== '') {
    apiParam += `&search=${params?.search}`
  }

  if (params?.status && params?.status !== '') {
    apiParam += `&status=${params?.status}`
  }

  if (params?.action && params?.action !== '') {
    apiParam += `&action=${params?.action}`
  }

  if (params?.search && params?.search !== '') {
    apiParam += `&search=${params?.search}`
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.ACTIVITY_LOG.GET_ACTIVITY_LOG}${apiParam}`);
  return response;
};


const getDataHouseApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(`${API_ENDPOINTS.DATA_HOUSE.GET_DATA_HOUSE}`, data);
  return response;
};

const getDataHouseDetailsApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.DATA_HOUSE.GET_DATA_HOUSE_DETAILS);
  return response;
};

const deleteDataHouseApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.delete(`${API_ENDPOINTS.DATA_HOUSE.DELETE_DATA_HOUSE}`, { data: data });
  return response;
};

export { loginApi, sendOtpApi, signupApi, getPhoneCodeApi, verifyOtpApi, getRoleListApi, getAccessLevelListApi, getPermissionListApi, getUserListApi, getUserDetailApi, resetPasswordApi, changePasswordApi, resendOtpApi, updateDetailsApi, getProfileApi, deleteUserApi, createUserApi, updateUserApi, getRoleManagementListApi, createRoleApi, updateRoleApi, deleteRoleApi, getPermissionManagementListApi, createPermissionApi, updatePermissionApi, deletePermissionApi, getTemplateListApi, createTemplateApi, getTemplateDetailApi, deleteTemplateApi, downloadTemplateApi, getTemplateForUserApi, uploadTemplateApi, getChartListApi, getChartDetailsApi, getChartDataApi, getChartDataByKpiApi, getIndicatorListApi, deleteTemplateDataApi, getActivityLogApi, getDataHouseApi, getDataHouseDetailsApi, deleteDataHouseApi };